import React, {useEffect, useRef} from "react";
import Chart from "chart.js/auto";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";


export default function DisbursedCumulative(props) {
    const canvas = useRef(null);

    const screenSize = (window.innerWidth >= 768);

    const data = {
        labels: props.labels.slice(-3),
        datasets: [
            {
                type: 'bar',
                label: 'Total Disbursement',
                backgroundColor: 'rgba(0, 116, 222, 1)',
                borderColor: 'rgba(0, 116, 222, 1)',
                data: props.dataset.slice(-3),
                fill: false,
                barThickness: 4,
            }
        ]
    };

    useEffect(() => {
        const formatNumberWithSpaces = (number) => {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        };

        const config = {
            data: data,
            options: {
                indexAxis: 'y',
                maintainAspectRatio: false,
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            padding: 30,
                            color: 'white',
                            pointStyle: 'circle',
                            usePointStyle: true,
                        }
                    },
                    tooltip: {
                        mode: "index",
                        intersect: false,
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.x !== null) {
                                    label += formatNumberWithSpaces(Math.round(context.parsed.x));
                                }
                                return label;
                            }
                        }
                    },
                },
                interaction: {
                    intersect: false,
                    mode: 'index',
                },
                title: {
                    display: false,
                    text: "Orders Chart",
                },
                elements: {
                    point: {
                        radius: 0
                    }
                },
                hover: {
                    mode: "nearest",
                    intersect: true,
                },
                scales: {
                    x:
                        {
                            display: true,
                            grid: {
                                display: true,
                                drawBorder: false,
                                color: "rgba(238, 238, 238, 0.1)",
                                zeroLineColor: "rgba(100, 100, 100, 0.1)",
                                zeroLineWidth: 1
                            },
                            ticks: {
                                color: 'white',
                                autoSkip: true,
                                maxTicksLimit: 10,
                                max: 20000000,
                                min: 0,
                                callback: function (value, index, values) {
                                    return value / 1e6 + 'M';
                                }
                            },
                        },
                    y: {
                        display: true,
                        title: {
                            display: true,
                            fontColor: 'white',
                            labelString: "Transaction values [USD]",
                        },
                        ticks: {
                            color: 'white',
                            autoSkip: true,
                            maxTicksLimit: 6,

                        },
                    },
                },
            },
        };

        const chart = new Chart(canvas.current, config);

        return () => {
            // need cleanup because React runs useEffect callback twice in dev env
            chart.destroy();
        };

    }, [props.labels, props.dataset, props.title, props.subtitle]);
    return (
        <>
            <div className="w-full h-fit">
                <p className={`text-yellow text-16-19 mb-6 ${screenSize && 'px-8'}`}>{props.title}</p>
                <div className="relative">
                    <canvas ref={canvas}></canvas>
                </div>
            </div>
        </>
    );
}
